export default "/images/0a3fb6c7df9c463537f50917ba9d2e65.avif";